export const newSongsData = [
  {
    title: "The Only Way Out - Acceptance",
    soundSource: "/songs/THE ONLY WAY OUT - ACCEPTANCE.mp3",
    lyrics: [
      { time: 0, text: "The only way out - Acceptance", firstLineInParagraph: true },
      { time: 4, text: "As I look through the rearview mirror", firstLineInParagraph: true, sectionTitle: "Verse 1" },
      { time: 8, text: "leaving regrets behind" },
      { time: 12, text: "Time's gift is distance," },
      { time: 16, text: "wounds leaving scars to remind" },
      { time: 20, text: "dancing through life", firstLineInParagraph: true },
      { time: 24, text: "Grow where your feet are" },
      { time: 28, text: "Finding my voice" },
      { time: 32, text: "I cry and move on" },
      { time: 36, text: "Looking for a moment when", firstLineInParagraph: true },
      { time: 40, text: "I'll have the courage to shine" },
      { time: 44, text: "Will Freedom come my way," },
      { time: 48, text: "I count the time," },
      { time: 52, text: "the only way out is through", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 56, text: "step by step" },
      { time: 60, text: "breath by breath" },
      { time: 64, text: "I'll find a way to move" },
      { time: 68, text: "the only way out is through", firstLineInParagraph: true },
      { time: 72, text: "Moment after moment" },
      { time: 76, text: "and love myself for who I am" },
      { time: 80, text: "So that others shall too" },
      { time: 84, text: "and love myself for who I am", firstLineInParagraph: true },
      { time: 88, text: "So that others shall too" },
      { time: 92, text: "As I come to terms with what happened", firstLineInParagraph: true, sectionTitle: "Verse 2" },
      { time: 96, text: "Laying new grounds to explore" },
      { time: 100, text: "I'll foster my powers," },
      { time: 104, text: "To fix what was broken before" },
      { time: 108, text: "Trusting fate has in store", firstLineInParagraph: true },
      { time: 112, text: "A million possibilities" },
      { time: 116, text: "Opening new doors," },
      { time: 120, text: "And never look back" },
      { time: 124, text: "the only way out is through", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 128, text: "step by step" },
      { time: 132, text: "breath by breath" },
      { time: 136, text: "I'll find a way to move" },
      { time: 140, text: "the only way out is through", firstLineInParagraph: true },
      { time: 144, text: "Moment after moment" },
      { time: 148, text: "and love myself for who I am" },
      { time: 152, text: "So that others shall too" },
      { time: 156, text: "Mending the pieces", firstLineInParagraph: true, sectionTitle: "Bridge" },
      { time: 160, text: "Mending the pieces" },
      { time: 164, text: "Mending the pieces" },
      { time: 168, text: "Mending the pieces" },
      { time: 172, text: "the only way out is through", firstLineInParagraph: true, sectionTitle: "Final Chorus" },
      { time: 176, text: "step by step" },
      { time: 180, text: "breath by breath" },
      { time: 184, text: "I'll find a way to move" },
      { time: 188, text: "the only way out is through", firstLineInParagraph: true },
      { time: 192, text: "Moment after moment" },
      { time: 196, text: "and love myself for who I am" },
      { time: 200, text: "So that others shall too" },
      { time: 204, text: "and love myself for who I am", firstLineInParagraph: true },
      { time: 208, text: "So that others shall too" }
    ]
  },
  {
    title: "Starseed - Identity",
    soundSource: "/songs/STARSEED - IDENTITY.mp3",
    lyrics: [
      { time: 0, text: "Star Seeds - Identity", firstLineInParagraph: true },
      { time: 4, text: "Waking with a feeling", firstLineInParagraph: true, sectionTitle: "Verse 1" },
      { time: 8, text: "seeking the embrace of the divine" },
      { time: 12, text: "The rhythm of my being" },
      { time: 16, text: "Is what I long to find" },
      { time: 20, text: "Living in the light everything is right", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 24, text: "Why it feels so dark" },
      { time: 28, text: "I release the night hoping that I might", firstLineInParagraph: true },
      { time: 32, text: "Step into the sun" },
      { time: 36, text: "We are star seeds, we are one", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 40, text: "We are not lost we all have love songs to be sung" },
      { time: 44, text: "We are star seeds, we are one", firstLineInParagraph: true },
      { time: 48, text: "We are not alone we have heart strings that play on" },
      { time: 52, text: "Deep into the core, deep into the core", firstLineInParagraph: true },
      { time: 56, text: "Deep inside the core keeps shining" },
      { time: 60, text: "Sensing a new dawning", firstLineInParagraph: true, sectionTitle: "Verse 2" },
      { time: 64, text: "How many times are we reborn?" },
      { time: 68, text: "lives are overflowing" },
      { time: 72, text: "weathering the storm" },
      { time: 76, text: "Living in the light everything is bright", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 80, text: "How to ignite the spark" },
      { time: 84, text: "Does the answer lie", firstLineInParagraph: true },
      { time: 88, text: "Swaying with the tide" },
      { time: 92, text: "If I may return" },
      { time: 96, text: "We are star seeds, we are one", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 100, text: "We are not lost we all have love songs to be sung" },
      { time: 104, text: "We are star seeds, we are one", firstLineInParagraph: true },
      { time: 108, text: "We are not alone we have heart strings to play on" },
      { time: 112, text: "Deep into the void, deep into the void", firstLineInParagraph: true },
      { time: 116, text: "Deep inside the void keeps calling" },
      { time: 120, text: "Hope is rising", firstLineInParagraph: true },
      { time: 124, text: "While we are holding on" },
      { time: 128, text: "Living in the light everything is right", firstLineInParagraph: true, sectionTitle: "Bridge" },
      { time: 132, text: "Why it feels so dark" },
      { time: 136, text: "I release the night hoping that I might", firstLineInParagraph: true },
      { time: 140, text: "Step into the sun" },
      { time: 144, text: "We are star seeds, we are one", firstLineInParagraph: true, sectionTitle: "Final Chorus" },
      { time: 148, text: "We are not lost we all have love songs to be sung" },
      { time: 152, text: "We are star seeds, we are one", firstLineInParagraph: true },
      { time: 156, text: "We are not alone we have heart strings to play on" },
      { time: 160, text: "Deep into the soul, deep into the soul", firstLineInParagraph: true, sectionTitle: "Outro" },
      { time: 164, text: "Deep inside the soul keeps shining" },
      { time: 168, text: "But we keep hiding" }
    ]
  },
  {
    title: "Secondary Gain - Chronic Pain",
    soundSource: "/songs/SECONDARY GAIN - CHRONIC PAIN.mp3",
    lyrics: [
      { time: 0, text: "Secondary Gain - pain?", firstLineInParagraph: true },
      { time: 4, text: "What do I get", firstLineInParagraph: true, sectionTitle: "Verse 1" },
      { time: 8, text: "In exchange for hurting" },
      { time: 12, text: "Your attention?" },
      { time: 16, text: "A reason for distraction?" },
      { time: 20, text: "A break from routine", firstLineInParagraph: true },
      { time: 24, text: "An excuse for not doing" },
      { time: 28, text: "Am I addicted to the pain?" },
      { time: 32, text: "Or to the secondary gain?" },
      { time: 36, text: "What do I get", firstLineInParagraph: true, sectionTitle: "Verse 2" },
      { time: 40, text: "In exchange for hurting" },
      { time: 44, text: "Your affection?" },
      { time: 48, text: "Temporary satisfaction?" },
      { time: 52, text: "A break from reality", firstLineInParagraph: true },
      { time: 56, text: "A sense of identity" },
      { time: 60, text: "A form of validation" },
      { time: 64, text: "For relying on you" },
      { time: 68, text: "Find the space between", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 72, text: "Earn and suffering" },
      { time: 76, text: "Shatter the chains" },
      { time: 80, text: "It's time to see" },
      { time: 84, text: "Dive down beneath the strain", firstLineInParagraph: true },
      { time: 88, text: "Then dig deeper," },
      { time: 92, text: "Unfold the gain" },
      { time: 96, text: "Turn the key", firstLineInParagraph: true },
      { time: 100, text: "Break the loop" },
      { time: 104, text: "Release the pattern" },
      { time: 108, text: "What do I get", firstLineInParagraph: true, sectionTitle: "Verse 3" },
      { time: 112, text: "In exchange for hurting" },
      { time: 116, text: "Your protection?" },
      { time: 120, text: "Lingering procrastination?" },
      { time: 124, text: "An excuse to feel low", firstLineInParagraph: true },
      { time: 128, text: "To take it painfully slow" },
      { time: 132, text: "Holding me stagnant" },
      { time: 136, text: "In self defeat" },
      { time: 140, text: "Find the space between", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 144, text: "Earn and suffering" },
      { time: 148, text: "Shatter the chains" },
      { time: 152, text: "It's time to see" },
      { time: 156, text: "Dive down beneath the strain", firstLineInParagraph: true },
      { time: 160, text: "Then dig deeper," },
      { time: 164, text: "Unfold the gain" },
      { time: 168, text: "Turn the key" },
      { time: 172, text: "Break the loop", firstLineInParagraph: true },
      { time: 176, text: "Release the pattern" },
      { time: 180, text: "Turn the key" },
      { time: 184, text: "An excuse for loathing", firstLineInParagraph: true, sectionTitle: "Bridge" },
      { time: 188, text: "Creating my own burden" },
      { time: 192, text: "An excuse to deny" },
      { time: 196, text: "My behaviours and baggage" },
      { time: 200, text: "An excuse to refuse", firstLineInParagraph: true },
      { time: 204, text: "My responsibilities" },
      { time: 208, text: "An excuse to ignore" },
      { time: 212, text: "My true potential" },
      { time: 216, text: "And never do what serves me best", firstLineInParagraph: true },
      { time: 220, text: "Cause it's terrifying and unknown" },
      { time: 224, text: "Turn the key", firstLineInParagraph: true, sectionTitle: "Outro" },
      { time: 228, text: "Break the loop" },
      { time: 232, text: "Release the pattern" }
    ]
  },
  {
    title: "Say No - Standing Up For Yourself",
    soundSource: "/songs/SAY NO - STANDING UP FOR YOURSELF.mp3",
    lyrics: [
      { time: 0, text: "Say no - Standing Up For Yourself", firstLineInParagraph: true },
      { time: 4, text: "Am I letting you down if I don't agree,", firstLineInParagraph: true, sectionTitle: "Verse 1" },
      { time: 8, text: "If I don't comply with your vision of me" },
      { time: 12, text: "You draw your line, but I can't draw mine", firstLineInParagraph: true },
      { time: 16, text: "Cause you know, I have places to be" },
      { time: 20, text: "I have faces to see" },
      { time: 24, text: "We live in a world of yesses", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 28, text: "Of  impulses, lies and guesses" },
      { time: 32, text: "Gaslighting, favours, behaviours" },
      { time: 36, text: "Oh I'm so tired of not being me (I'm gonna)" },
      { time: 40, text: "Just say no, just say no, just say no, just say no", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 44, text: "And while I'm saying no to you I'm saying yes to me too." },
      { time: 48, text: "Shall I apologise, if for once I choose me,", firstLineInParagraph: true, sectionTitle: "Verse 2" },
      { time: 52, text: "If I don't appear like you want me to be" },
      { time: 56, text: "You say it it's all fine, but I can read your mind", firstLineInParagraph: true },
      { time: 60, text: "Oh you're pretending to be" },
      { time: 64, text: "Someone you'll never be" },
      { time: 68, text: "We live in a world of fake news", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 72, text: "With words turning into blurred views" },
      { time: 76, text: "catfishing,  blackmail,  betrayals" },
      { time: 80, text: "Oh I'm so tired of not being me (I'm gonna)" },
      { time: 84, text: "Just say no, just say no, just say no, just say no", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 88, text: "And while I'm saying no to you I'm saying yes to me." },
      { time: 92, text: "I no longer want to reside in the shadow", firstLineInParagraph: true, sectionTitle: "Bridge" },
      { time: 96, text: "I vow to be free to seek out the real me" },
      { time: 100, text: "I don't want to make promises I cannot keep" },
      { time: 104, text: "I'm done feeling guilty" },
      { time: 108, text: "For saying no to things" },
      { time: 112, text: "That don't help me grow" },
      { time: 116, text: "So from this day forth", firstLineInParagraph: true },
      { time: 120, text: "I'm just saying no" },
      { time: 124, text: "I just want to be free, free to be me", firstLineInParagraph: true },
      { time: 128, text: "Your over reliance on me is where we disagree." },
      { time: 132, text: "We live in a world of choices", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 136, text: "Confused by too many voices" },
      { time: 140, text: "Doormatting,  bubbles and  rubbles" },
      { time: 144, text: "Oh I'm so tired of not being me (I'm gonna)" },
      { time: 148, text: "Just say no, no oh no", firstLineInParagraph: true, sectionTitle: "Final Chorus" },
      { time: 152, text: "Just say no, no oh no" },
      { time: 156, text: "(To trolls and to gurus", firstLineInParagraph: true, sectionTitle: "Outro" },
      { time: 160, text: "To racists and homophobes" },
      { time: 164, text: "To haters and know-it-alls" },
      { time: 168, text: "To bullies and brutes" },
      { time: 172, text: "To  the \"I'm a God\" narcissist", firstLineInParagraph: true },
      { time: 176, text: "To the opinionated conformists" },
      { time: 180, text: "To the spilled milk cryer liars," },
      { time: 184, text: "To the violent and rude)" },
      { time: 188, text: "Maybe I will cry at your wedding", firstLineInParagraph: true },
      { time: 192, text: "and maybe I will dance at your funeral" },
      { time: 196, text: "What I'd like to say to your humoral self is" }
    ]
  },
  {
    title: "Pieces - Anger",
    soundSource: "/songs/PIECES - ANGER.mp3",
    lyrics: [
      { time: 0, text: "Pieces - Anger", firstLineInParagraph: true },
      { time: 4, text: "I know there's a lesson here", firstLineInParagraph: true, sectionTitle: "Verse 1" },
      { time: 8, text: "I have been down this road before" },
      { time: 12, text: "I thought I had it this time" },
      { time: 16, text: "have I missed something am I blind" },
      { time: 20, text: "I must be playing the same old game", firstLineInParagraph: true },
      { time: 24, text: "Cause it always ends the same way" },
      { time: 28, text: "With the pressure in the chest" },
      { time: 32, text: "And the shattering sound" },
      { time: 36, text: "How can something so wrong feel right", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 40, text: "How much was it yours, how much was mine" },
      { time: 44, text: "Does it even matter at all" },
      { time: 48, text: "As all is left is" },
      { time: 52, text: "pieces", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 56, text: "all is left is pieces" },
      { time: 60, text: "All is left is pieces" },
      { time: 64, text: "Cause all is left is pieces" },
      { time: 68, text: "There are stones I don't want to throw", firstLineInParagraph: true, sectionTitle: "Verse 2" },
      { time: 72, text: "Gingerly walking in between" },
      { time: 76, text: "Scattered fragments of life" },
      { time: 80, text: "And the vision of us" },
      { time: 84, text: "Torn between the hurt", firstLineInParagraph: true },
      { time: 88, text: "And the sense of being free" },
      { time: 92, text: "to start once again" },
      { time: 96, text: "with someone more aligned" },
      { time: 100, text: "One part of me screams let's ride", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 104, text: "The other one holds by twisting inside" },
      { time: 108, text: "the hollow burns the hollow burns" },
      { time: 112, text: "As all is left is" },
      { time: 116, text: "pieces", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 120, text: "all is left is pieces" },
      { time: 124, text: "all is left is pieces" },
      { time: 128, text: "all is left is pieces" },
      { time: 132, text: "the hollow burns the hollow burns", firstLineInParagraph: true, sectionTitle: "Bridge" },
      { time: 136, text: "Does it even matter at all" },
      { time: 140, text: "the hollow burns the hollow burns" },
      { time: 144, text: "Does it even matter" },
      { time: 148, text: "the hollow burns the hollow burns", firstLineInParagraph: true },
      { time: 152, text: "Does it even matter at all" },
      { time: 156, text: "the hollow burns the hollow burns" },
      { time: 160, text: "When all is left is", firstLineInParagraph: true },
      { time: 164, text: "Pieces", firstLineInParagraph: true, sectionTitle: "Outro" },
      { time: 168, text: "All is pieces" },
      { time: 172, text: "Is all in pieces" },
      { time: 176, text: "All is pieces" }
    ]
  },
  {
    title: "Be Heard - Effective Communication",
    soundSource: "/songs/BE HEARD EFFECTIVE COMMUNICATION.mp3",
    lyrics: [
      { time: 0, text: "Be heard - Effective Communication", firstLineInParagraph: true },
      { time: 4, text: "As I am shut down", firstLineInParagraph: true, sectionTitle: "Verse 1" },
      { time: 8, text: "I fall on deaf ears" },
      { time: 12, text: "I can't confront you" },
      { time: 16, text: "And it stirs inside" },
      { time: 20, text: "So I'd rather stay quiet", firstLineInParagraph: true },
      { time: 24, text: "And get crushed" },
      { time: 28, text: "Will anyone listen" },
      { time: 32, text: "I feel small" },
      { time: 36, text: "I want to be liked", firstLineInParagraph: true },
      { time: 40, text: "I can't be made fun of" },
      { time: 44, text: "I just want to help" },
      { time: 48, text: "How embarrassing" },
      { time: 52, text: "Am I speaking my truth", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 56, text: "Or am I lying to myself and others" },
      { time: 60, text: "What is she hearing Why is she hearing" },
      { time: 64, text: "What I felt before I talked" },
      { time: 68, text: "How can I be heard all over this noise", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 72, text: "How can I learn, trust my own" },
      { time: 76, text: "inner voice" },
      { time: 80, text: "If I wanna be heard" },
      { time: 84, text: "I wanna be heard" },
      { time: 88, text: "If I wanna be heard" },
      { time: 92, text: "Maybe I'll just have to listen first" },
      { time: 96, text: "If I wanna be heard", firstLineInParagraph: true },
      { time: 100, text: "Oh I wanna be heard" },
      { time: 104, text: "If I wanna be heard" },
      { time: 108, text: "Maybe I'll just have to listen first" },
      { time: 112, text: "Why taking on this", firstLineInParagraph: true, sectionTitle: "Verse 2" },
      { time: 116, text: "that's not mine to solve, like" },
      { time: 120, text: "flowers or burdens" },
      { time: 124, text: "Saving face won't resolve it" },
      { time: 128, text: "Did I let you down", firstLineInParagraph: true },
      { time: 132, text: "Was I dismissive" },
      { time: 136, text: "Do you enjoy your frown" },
      { time: 140, text: "Or are you important?" },
      { time: 144, text: "Am I speaking my truth", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 148, text: "Or am I lying to myself and others" },
      { time: 152, text: "What is she hearing Why is she hearing" },
      { time: 156, text: "What I felt before I talked" },
      { time: 160, text: "How can I be heard all over this noise", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 164, text: "How can I learn, trust my own" },
      { time: 168, text: "inner voice" },
      { time: 172, text: "If I wanna be heard" },
      { time: 176, text: "I wanna be heard" },
      { time: 180, text: "If I wanna be heard" },
      { time: 184, text: "Maybe I'll just have to listen first" },
      { time: 188, text: "If I wanna be heard", firstLineInParagraph: true },
      { time: 192, text: "Oh I wanna be heard" },
      { time: 196, text: "If I wanna be heard" },
      { time: 200, text: "Maybe I'll just have to listen first" }
    ]
  },
  {
    title: "More Than Me - Self Esteem",
    soundSource: "/songs/MORE THAN ME - SELF ESTEEM.mp3",
    lyrics: [
      { time: 0, text: "More Than Me - Confidence And Self-Esteem", firstLineInParagraph: true },
      { time: 4, text: "That voice in my head", firstLineInParagraph: true, sectionTitle: "Verse 1" },
      { time: 8, text: "That doesn't believe I can make it" },
      { time: 12, text: "That always think that I'll fake it" },
      { time: 16, text: "Every time" },
      { time: 20, text: "That voice in my head", firstLineInParagraph: true },
      { time: 24, text: "That makes me doubt that I'm worth it" },
      { time: 28, text: "Implying that I should forfeit" },
      { time: 32, text: "Every time" },
      { time: 36, text: "finding confidence each time is draining,", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 40, text: "Tomorrow me needs today me gaining," },
      { time: 44, text: "Who is the me who speaks these words" },
      { time: 48, text: "Who is the me who listens" },
      { time: 52, text: "without giving in" },
      { time: 56, text: "taking back what we hold within" },
      { time: 60, text: "And discover that, discover that" },
      { time: 64, text: "I am more than my mind", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 68, text: "I am more than my body" },
      { time: 72, text: "When doubt washes over" },
      { time: 76, text: "It's time to swim or sink" },
      { time: 80, text: "I' m not my thoughts", firstLineInParagraph: true },
      { time: 84, text: "I am not my knots" },
      { time: 88, text: "I'm not my beliefs" },
      { time: 92, text: "I am more than just me" },
      { time: 96, text: "More than just me" },
      { time: 100, text: "That voice in my head", firstLineInParagraph: true, sectionTitle: "Verse 2" },
      { time: 104, text: "says everyone else here knows better" },
      { time: 108, text: "What they are doing, why bother" },
      { time: 112, text: "compare and despair." },
      { time: 116, text: "But who are they being", firstLineInParagraph: true },
      { time: 120, text: "Or what am I seeing" },
      { time: 124, text: "What am I believing" },
      { time: 128, text: "Who do I trust" },
      { time: 132, text: "If my faults could bring inspiration", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 136, text: "Instead of immobilisation" },
      { time: 140, text: "Today I'll do things a different way" },
      { time: 144, text: "i'll say no thank you not today" },
      { time: 148, text: "is it like thought or sin" },
      { time: 152, text: "To aim to live without and within" },
      { time: 156, text: "And discover that" },
      { time: 160, text: "I am more than my mind", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 164, text: "I am more than my body" },
      { time: 168, text: "When doubt washes over" },
      { time: 172, text: "It's time to swim (or sink)" },
      { time: 176, text: "I am not my thoughts", firstLineInParagraph: true },
      { time: 180, text: "I am not my knots" },
      { time: 184, text: "I'm not my beliefs" },
      { time: 188, text: "I'm more than just me" },
      { time: 192, text: "More than just me" },
      { time: 196, text: "More than just me" },
      { time: 200, text: "What if I shake it", firstLineInParagraph: true, sectionTitle: "Bridge" },
      { time: 204, text: "What if I make it" },
      { time: 208, text: "By - being who I truly am" },
      { time: 212, text: "being who I truly am" },
      { time: 216, text: "What if I shake it", firstLineInParagraph: true },
      { time: 220, text: "What if I make it" },
      { time: 224, text: "By being who I truly am" },
      { time: 228, text: "Being who I am cause" },
      { time: 232, text: "I am more than my mind", firstLineInParagraph: true, sectionTitle: "Final Chorus" },
      { time: 236, text: "I am more than my body" },
      { time: 240, text: "When doubt washes over" },
      { time: 244, text: "It's time to swim or sink" },
      { time: 248, text: "I am not my thoughts", firstLineInParagraph: true },
      { time: 252, text: "I am not my knots" },
      { time: 256, text: "I'm not my beliefs" },
      { time: 260, text: "More than just me" },
      { time: 264, text: "More than just me" },
      { time: 268, text: "More than just me" }
    ]
  },
  {
    title: "Limitless Boundaries - Managing Boundaries",
    soundSource: "/songs/LIMITLESS BOUNDARIES - MANAGING BOUNDARIES.mp3",
    lyrics: [
      { time: 0, text: "Limitless Boundaries - Personal Boundaries", firstLineInParagraph: true },
      { time: 4, text: "As the Highwire heads into the wind", firstLineInParagraph: true, sectionTitle: "Verse 1" },
      { time: 8, text: "Unwinding into the dark sea" },
      { time: 12, text: "The lighthouse disappears into the distance" },
      { time: 16, text: "The beacon of hope remains with me" },
      { time: 20, text: "For a safe journey through the night sky", firstLineInParagraph: true },
      { time: 24, text: "Far and away from my home" },
      { time: 28, text: "I'm the sole and only master of my voyage" },
      { time: 32, text: "I'll set my course for the unknown" },
      { time: 36, text: "Rise and fall", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 40, text: "If I trust in something I must give it my all" },
      { time: 44, text: "Cause I, I know" },
      { time: 48, text: "That if I stand for nothing, I will fall for it all" },
      { time: 52, text: "And I believe" },
      { time: 56, text: "My own true north will guide me" },
      { time: 60, text: "through limitless boundaries, limitless boundaries" },
      { time: 64, text: "when only faith is braving through the rain", firstLineInParagraph: true, sectionTitle: "Verse 2" },
      { time: 68, text: "leading the way to tame the storm" },
      { time: 72, text: "far above the surface of the clouds" },
      { time: 76, text: "the seven sisters still adorn" },
      { time: 80, text: "Rise and fall", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 84, text: "If I trust in something I must give it my all" },
      { time: 88, text: "Cause I, I know" },
      { time: 92, text: "That if I stand for nothing, I will fall for it all" },
      { time: 96, text: "If I believe" },
      { time: 100, text: "My own true north will guide me" },
      { time: 104, text: "through limitless boundaries, limitless boundaries" },
      { time: 108, text: "still waters await", firstLineInParagraph: true, sectionTitle: "Bridge" },
      { time: 112, text: "to quench the thirst for knowledge" },
      { time: 116, text: "that only riding the waves" },
      { time: 120, text: "will release" },
      { time: 124, text: "It's easy to go wayward", firstLineInParagraph: true },
      { time: 128, text: "when we hear the sirens sing" },
      { time: 132, text: "but we will find the way home" },
      { time: 136, text: "if we quell the waves within" },
      { time: 140, text: "(and embrace) limitless boundaries" },
      { time: 144, text: "(and embrace) limitless boundaries" },
      { time: 148, text: "Rise and fall", firstLineInParagraph: true, sectionTitle: "Final Chorus" },
      { time: 152, text: "If I trust in something I must give it my all" },
      { time: 156, text: "Cause I, I know" },
      { time: 160, text: "That if I stand for nothing, I will fall for it all" },
      { time: 164, text: "And I believe" },
      { time: 168, text: "My own true north will guide me" },
      { time: 172, text: "through limitless boundaries, limitless boundaries" },
      { time: 176, text: "limitless boundaries, limitless boundaries" }
    ]
  },
  {
    title: "Firestorm - Action Vs Reaction",
    soundSource: "/songs/FIRESTORM - ACTION VS REACTION.mp3",
    lyrics: [
      { time: 0, text: "Firestorm - Action Vs Reaction", firstLineInParagraph: true },
      { time: 4, text: "The wind is still and calm", firstLineInParagraph: true, sectionTitle: "Verse 1" },
      { time: 8, text: "There's no sign a storm is on the horizon" },
      { time: 12, text: "It just takes a word" },
      { time: 16, text: "To trigger clouds" },
      { time: 20, text: "Dull, unwanted thoughts", firstLineInParagraph: true },
      { time: 24, text: "Bubbling dry and hot below the surface" },
      { time: 28, text: "Feelings start to spill" },
      { time: 32, text: "From the abyss" },
      { time: 36, text: "Gotta know the way to go the way", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 40, text: "It takes a single spark to ignite the dark" },
      { time: 44, text: "Get ready to face a", firstLineInParagraph: true },
      { time: 48, text: "Firestorm", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 52, text: "It's too late to tame it" },
      { time: 56, text: "Fireworks" },
      { time: 60, text: "Simmering, braking" },
      { time: 64, text: "Firestorm", firstLineInParagraph: true },
      { time: 68, text: "wait till it passes" },
      { time: 72, text: "Fireworks" },
      { time: 76, text: "rise from the ashes" },
      { time: 80, text: "calm will return", firstLineInParagraph: true },
      { time: 84, text: "And the skin will have healed from the burn" },
      { time: 88, text: "We'll be one step closer to be free from fear" },
      { time: 92, text: "Prisms face to face", firstLineInParagraph: true, sectionTitle: "Verse 2" },
      { time: 96, text: "Truths collide the surface of the mirror" },
      { time: 100, text: "Prisons made of gold" },
      { time: 104, text: "Fuelling delusions" },
      { time: 108, text: "Seeing there's a choice", firstLineInParagraph: true },
      { time: 112, text: "How decisions cast will affect us" },
      { time: 116, text: "Hike uncharted paths" },
      { time: 120, text: "To conquer illusions" },
      { time: 124, text: "Gotta know the way to go the way", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 128, text: "It takes a single quark to ignite the spark" },
      { time: 132, text: "Get ready to face a", firstLineInParagraph: true },
      { time: 136, text: "Firestorm", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 140, text: "It's too late to tame it" },
      { time: 144, text: "Fireworks" },
      { time: 148, text: "Simmering, braking" },
      { time: 152, text: "Firestorm", firstLineInParagraph: true },
      { time: 156, text: "wait till it passes" },
      { time: 160, text: "Fireworks" },
      { time: 164, text: "rise from the ashes" },
      { time: 168, text: "calm will return", firstLineInParagraph: true },
      { time: 172, text: "And the skin will have healed from the burn" },
      { time: 176, text: "We'll be one step closer to be free from fear" },
      { time: 180, text: "From fear", firstLineInParagraph: true, sectionTitle: "Bridge" },
      { time: 184, text: "Of judgement" },
      { time: 188, text: "Of falsehood" },
      { time: 192, text: "Of failure and gain" },
      { time: 196, text: "From fear", firstLineInParagraph: true },
      { time: 200, text: "Of denial" },
      { time: 204, text: "Of criticism" },
      { time: 208, text: "Of suffering and pain" },
      { time: 212, text: "And when the calm will return", firstLineInParagraph: true, sectionTitle: "Outro" },
      { time: 216, text: "And the heart will have healed from the burn" },
      { time: 220, text: "We'll be one step closer to be free" }
    ]
  },
  {
    title: "Conquer - Manifestation",
    soundSource: "/songs/CONQUER - MANIFESTATION.mp3",
    lyrics: [
      { time: 0, text: "Conquer - Manifestation", firstLineInParagraph: true },
      { time: 4, text: "Making dreams come true", firstLineInParagraph: true, sectionTitle: "Verse 1" },
      { time: 8, text: "What do you want to create" },
      { time: 12, text: "What do you wish for?" },
      { time: 16, text: "Make room to reflect", firstLineInParagraph: true },
      { time: 20, text: "Connect with your future self" },
      { time: 24, text: "Choose to be happy" },
      { time: 28, text: "Trust in the process", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 32, text: "See it, feel it, believe it" },
      { time: 36, text: "Go forth and conquer" },
      { time: 40, text: "Trust in the process", firstLineInParagraph: true },
      { time: 44, text: "See it, feel it, believe it" },
      { time: 48, text: "Go forth and conquer" },
      { time: 52, text: "Go forth and conquer" },
      { time: 56, text: "every single step", firstLineInParagraph: true, sectionTitle: "Verse 2" },
      { time: 60, text: "one small win, one at a time" },
      { time: 64, text: "we'll celebrate it" },
      { time: 68, text: "Not afraid to fall", firstLineInParagraph: true },
      { time: 72, text: "Riding the wave of your life" },
      { time: 76, text: "Be your own hero." },
      { time: 80, text: "Trust in the process", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 84, text: "See it, feel it, believe it" },
      { time: 88, text: "Go forth and conquer" },
      { time: 92, text: "Trust in the process", firstLineInParagraph: true },
      { time: 96, text: "See it, feel it, believe it" },
      { time: 100, text: "Go forth and conquer" },
      { time: 104, text: "take a leap of faith", firstLineInParagraph: true, sectionTitle: "Bridge" },
      { time: 108, text: "don't feel alone we're all here" },
      { time: 112, text: "the ground is our crown" },
      { time: 116, text: "the ground is our crown" },
      { time: 120, text: "It's never too late", firstLineInParagraph: true },
      { time: 124, text: "Just flow, be free, trust yourself" },
      { time: 128, text: "Go on, own your throne" },
      { time: 132, text: "Go on, own your throne" },
      { time: 136, text: "Trust in the process", firstLineInParagraph: true, sectionTitle: "Final Chorus" },
      { time: 140, text: "Be your own hero" },
      { time: 144, text: "See it, feel it, believe it" },
      { time: 148, text: "Be your own hero" },
      { time: 152, text: "Go forth and conquer" },
      { time: 156, text: "Be your own hero" },
      { time: 160, text: "Trust in the process", firstLineInParagraph: true },
      { time: 164, text: "Be your own hero" },
      { time: 168, text: "See it, feel it, believe it" },
      { time: 172, text: "Be your own hero" },
      { time: 176, text: "Go forth and conquer" },
      { time: 180, text: "Be your own hero" },
      { time: 184, text: "take a leap of faith", firstLineInParagraph: true, sectionTitle: "Outro" },
      { time: 188, text: "It's never too late" },
      { time: 192, text: "Go on, earn your throne" },
      { time: 196, text: "Go on, own your throne" }
    ]
  },
  {
    title: "Blank Canvas - Fear of the Unknown",
    soundSource: "/songs/BLANK CANVAS - FEAR OF THE UNKNOWN.mp3",
    lyrics: [
      { time: 0, text: "Blank Canvas", firstLineInParagraph: true },
      { time: 4, text: "The white void is staring", firstLineInParagraph: true, sectionTitle: "Verse 1" },
      { time: 8, text: "Right back at me" },
      { time: 12, text: "As I take the first the step into the unknown" },
      { time: 16, text: "I am willing to be guided", firstLineInParagraph: true },
      { time: 20, text: "Cause I don't know what to do" },
      { time: 24, text: "Between the likes of me and you" },
      { time: 28, text: "And so I breathe, slow and deep", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 32, text: "Longing for the first brushstroke to begin" },
      { time: 36, text: "And the colours I see leap out of me" },
      { time: 40, text: "I don't want you to define me for what I have been", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 44, text: "Do we want us to fall down again in the big deep?" },
      { time: 48, text: "We can't let the past define us but what can we be?" },
      { time: 52, text: "Can we paint this white blank canvas and rewrite history?" },
      { time: 56, text: "Whispering colours", firstLineInParagraph: true, sectionTitle: "Verse 2" },
      { time: 60, text: "Are the old bristles true?" },
      { time: 64, text: "Or are they feelings hung tight to memories" },
      { time: 68, text: "The structure is shaking", firstLineInParagraph: true },
      { time: 72, text: "The shackles are loose" },
      { time: 76, text: "Calling for something or someone new" },
      { time: 80, text: "And now I breathe, seeking peace", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 84, text: "weaving hues are streaming into tapestries" },
      { time: 88, text: "As I close my eyes I'm ready to release" },
      { time: 92, text: "I don't want you to define me for what I have been", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 96, text: "Do we want us to fall down again in the big deep?" },
      { time: 100, text: "We can't let the past define us but what can we be?" },
      { time: 104, text: "Can we paint this white blank canvas and rewrite history?" }
    ]
  },
  {
    title: "I Learn - Fear of Failure",
    soundSource: "/songs/I LEARN - FEAR OF FAILURE.mp3",
    lyrics: [
      { time: 0, text: "I Learn - Fear of Failure and learning", firstLineInParagraph: true },
      { time: 4, text: "Teacher,", firstLineInParagraph: true, sectionTitle: "Verse 1" },
      { time: 8, text: "What do you expect of me," },
      { time: 12, text: "Do you assume I should understand" },
      { time: 16, text: "And accept every breath you breathe" },
      { time: 20, text: "Mother,", firstLineInParagraph: true },
      { time: 24, text: "I'm only human" },
      { time: 28, text: "What must I do to make you happy" },
      { time: 32, text: "Other than perfect" },
      { time: 36, text: "It took me so long", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 40, text: "To stop spreading blame" },
      { time: 44, text: "I am now taking the reins of my life" },
      { time: 48, text: "I am ready to claim" },
      { time: 52, text: "Every mistake as my chance to grow", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 56, text: "A stepping stone vital to achieving every goal" },
      { time: 60, text: "So I embrace them" },
      { time: 64, text: "With all my all" },
      { time: 68, text: "Cause I never lose, either I win or I learn" },
      { time: 72, text: "I never lose, either I win or I learn" },
      { time: 76, text: "Father,", firstLineInParagraph: true, sectionTitle: "Verse 2" },
      { time: 80, text: "What are these rules you impose" },
      { time: 84, text: "I am trying, but no matter what I do" },
      { time: 88, text: "it's not quite enough for you" },
      { time: 92, text: "Brother/sister,", firstLineInParagraph: true },
      { time: 96, text: "Please understand me" },
      { time: 100, text: "Forgive me if I can't always be" },
      { time: 104, text: "The role model that you need" },
      { time: 108, text: "It took me so long", firstLineInParagraph: true, sectionTitle: "Pre-Chorus" },
      { time: 112, text: "To pick myself up" },
      { time: 116, text: "I am now making the shape of my life" },
      { time: 120, text: "And prove to me that" },
      { time: 124, text: "Every mistake is my chance to grow", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 128, text: "A stepping stone vital to achieving every goal" },
      { time: 132, text: "So I embrace them" },
      { time: 136, text: "With all my all" },
      { time: 140, text: "Cause I never lose, either I win or I learn" },
      { time: 144, text: "I never lose, either I win or I learn" },
      { time: 148, text: "I am ready to go the distance", firstLineInParagraph: true, sectionTitle: "Bridge" },
      { time: 152, text: "I'm ready to run the extra mile" },
      { time: 156, text: "I am willing to do what people preach but never do" },
      { time: 160, text: "To dream as big as I can dream" },
      { time: 164, text: "Ten thousand hours" },
      { time: 168, text: "Of blood, sweat and tears" },
      { time: 172, text: "To tumble and fall" },
      { time: 176, text: "And then back up," },
      { time: 180, text: "Cause I never lose, either I win or I learn" },
      { time: 184, text: "God", firstLineInParagraph: true, sectionTitle: "Final Verse" },
      { time: 188, text: "Why so serious" },
      { time: 192, text: "If you didn't want me to sin" },
      { time: 196, text: "Why make it so sweet to win" },
      { time: 200, text: "Every mistake is my chance to grow", firstLineInParagraph: true, sectionTitle: "Final Chorus" },
      { time: 204, text: "A stepping stone vital to achieving every goal" },
      { time: 208, text: "So I embrace them" },
      { time: 212, text: "With all my all" },
      { time: 216, text: "Cause I never lose, either I win or I learn" },
      { time: 220, text: "I never lose, either I win or I learn" },
      { time: 224, text: "I never lose, either I win or I learn" }
    ]
  },
  {
    title: "Dear Child - Inner Child",
    soundSource: "/songs/DEAR CHILD - INNER CHILD.mp3",
    lyrics: [
      { time: 0, text: "Dear Child - A song about inner child healing", firstLineInParagraph: true },
      { time: 4, text: "Dear child, I am here for you", firstLineInParagraph: true, sectionTitle: "Verse" },
      { time: 8, text: "I know you've been feeling, unwanted and lost" },
      { time: 12, text: "To tell you the truth I don't know what I'm doing" },
      { time: 16, text: "I'm learning as I go, like you do And I try my best" },
      { time: 20, text: "Dear child, You felt misunderstood", firstLineInParagraph: true },
      { time: 24, text: "Shunned and abandoned, Shunned and abandoned" },
      { time: 28, text: "But don't we all" },
      { time: 32, text: "No matter how it feels, Hard or at ease" },
      { time: 36, text: "The squeaky wheel, The squeaky wheel" },
      { time: 40, text: "gets all the grease" },
      { time: 44, text: "The feeling that you don't belong has made me a warrior", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 48, text: "The reason why I stand so tall is that you held long" },
      { time: 52, text: "I'm still here to right my wrongs" },
      { time: 56, text: "Head up and going strong" },
      { time: 60, text: "I survived, I survive" },
      { time: 64, text: "That feeling of being lost and gone has broken barriers" },
      { time: 68, text: "if I get up each time I fall is cause you held on" },
      { time: 72, text: "I don't know defeat cause I'll have one more try" },
      { time: 76, text: "I don't know defeat cause I'll go till I die" },
      { time: 80, text: "Dear child, You've done your deeds", firstLineInParagraph: true, sectionTitle: "Verse" },
      { time: 84, text: "My ally, I hear you, I see you I feel your needs" },
      { time: 88, text: "Cause you walked by with softer lines" },
      { time: 92, text: "You're living within me you matter, You matter," },
      { time: 96, text: "oh don't you cry" },
      { time: 100, text: "The feeling that you don't belong has made me a warrior", firstLineInParagraph: true, sectionTitle: "Chorus" },
      { time: 104, text: "The reason why I stand so tall is that you held long" },
      { time: 108, text: "I'm still here to right my wrongs" },
      { time: 112, text: "Head up and going strong" },
      { time: 116, text: "I survived, I survive" },
      { time: 120, text: "That feeling of being lost and gone has broken barriers" },
      { time: 124, text: "if I get up each time I fall is cause you held on" },
      { time: 128, text: "I don't know defeat cause I'll have one more try" },
      { time: 132, text: "I don't know defeat cause I'll go till I die" },
      { time: 136, text: "Now I keep failing forward", firstLineInParagraph: true, sectionTitle: "Bridge" },
      { time: 140, text: "As you made me who I am" },
      { time: 144, text: "Your struggles have built and made all that I stand for" },
      { time: 148, text: "In the world" },
      { time: 152, text: "Who I am" },
      { time: 156, text: "In the world" },
      { time: 160, text: "What I am" },
      { time: 164, text: "In the world" },
      { time: 168, text: "Why I am" },
      { time: 172, text: "In the world" },
      { time: 176, text: "Why I am" }
    ]
  }
]
